import { Component, OnInit, OnDestroy } from '@angular/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { MembershipCodeService } from '../services/membership-code.service';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { BaseEditComponent } from '../../core/common/base-component';
import { SubscriptionPlansService } from '../../subscription-plans/services/subscription-plans.service';
import 'rxjs/add/observable/zip';
import { Observable } from 'rxjs/Observable';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'ch-membership-code-edit',
  templateUrl: './membership-code-edit.component.html',
  styleUrls: ['./membership-code-edit.component.css']
})
export class MembershipCodeEditComponent extends BaseEditComponent implements OnInit, OnDestroy {
  private membershipCodeId: string;
  public membershipCodeData: any = {};
  public codeName: string;
  public types = [{ value: 'DISCOUNT', text: 'Discount - Employment Proof Required' }, { value: 'STAFF_INCENTIVE', text: 'Staff Incentive - Employment Stage Skipped' }];
  public editMode: boolean;
  public plansList: any;
  public membershipCode$: any;
  public showPlans: boolean;
  private unsubscribe$: Subject<any> = new Subject<any>();

  constructor(
    private membershipCodeService: MembershipCodeService,
    private subscriptionPlansService: SubscriptionPlansService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private routeHelperService: RouteHelperService,
    private titleService: Title,
  ) {
    super();
  }

  ngOnInit() {
    const plans$ = this.subscriptionPlansService.getReferralCodePlansShort();
    const membershipCode$ = this.activatedRoute.queryParamMap.map((params: Params) => params.params);

    Observable.zip(plans$, membershipCode$)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([plans, membershipCode]) => {
        this.plansList = plans.json();

        this.editMode = this.routeHelperService.isCurrentPageEdit();
        this.membershipCodeId = membershipCode.id;

        if (this.editMode) {
          this.fetchData(this.membershipCodeId);
        } else {
          this.membershipCodeData.type = 'DISCOUNT';
          this.titleService.setTitle(`New Promo Code | CODE Hospitality CMS`);
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.unsubscribe();
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private fetchData(id: string) {
    this.loading = true;
    this.membershipCodeService.getMembershipCode(id).subscribe(
      data => {
        this.membershipCodeData = data.json();
        this.codeName = this.membershipCodeData.name;
        this.titleService.setTitle(`${this.membershipCodeData.name} | Promo Codes | CODE Hospitality CMS`);
        this.toggleFreeSubscription(!this.membershipCodeData.isFreeSubscription)

        this.loading = false;
        this.loaded = true;
      },
      error => {
        this.loading = false;
        this.loaded = true;
      }
    );
  }

  public edit(form) {
    if (!form.valid) {
      for (const i in form.controls) {
        form.controls[i].markAsTouched();
      }

      return;
    }

    const reqData: any = {};
    for (const i in this.membershipCodeData) {
      reqData[i] = this.membershipCodeData[i];
    }

    this.loading = true;
    const methodName = this.editMode ? 'updateMembershipCode' : 'addMembershipCode';
    this.membershipCodeService[methodName](reqData).subscribe(
      resp => {
        this.loading = false;
        this.cancel();
      },
      error => {
        this.loading = false;
      }
    );
  }

  public toggleFreeSubscription(val: boolean) {
    if (val) {
      this.membershipCodeData.overridePaidMembership = false;
      this.membershipCodeData.employerName = null;
      this.showPlans = true;
    } else {
      this.showPlans = false;
    }
  }

  public toggleOverridePaidMembership(val: boolean) {
    if (!val) {
      this.membershipCodeData.employerName = null;
    }
  }

  public expiryDateChange(value) {
    const d = new Date(value._d);
    this.membershipCodeData.expiryDate = d;
  }

  public cancel() {
    this.router.navigateByUrl('/admin/membership-codes');
  }

  public generateRandomCode() {
    const targetSymbols = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const targetLength = 8;
    let result = '';
    for (let i = 0; i < targetLength; i++) {
      result += targetSymbols.charAt(Math.floor(Math.random() * targetSymbols.length));
    }

    this.membershipCodeData.code = result;

    return false;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/membership-code/membership-code-edit/membership-code-edit.component.ts